import { defineStore } from "pinia";
// 定义一个关于meta的store
const metaInfoStore = defineStore("metaInfo", {

  state: () => ({
    title:'', 
    keywords:'',
    description:'',
  }),
  getters: { },
  // 类似methods
  actions: {
    setTitle(data) {
     this.title = data
    },
    setKeywords(data) {
      this.keywords = data
     },
     setDescription(data) {
      this.description = data
     },
  },
  persist: {
    storage: sessionStorage, //   sessionStorage localStorage
  },
}



);

export default metaInfoStore;
